import { render } from "./CalendarMonths.vue?vue&type=template&id=22066ca2&scoped=true"
import script from "./CalendarMonths.vue?vue&type=script&lang=js"
export * from "./CalendarMonths.vue?vue&type=script&lang=js"

import "./CalendarMonths.vue?vue&type=style&index=0&id=22066ca2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22066ca2"]])

export default __exports__